// extracted by mini-css-extract-plugin
export default {"selectedDate":"mini-calendar_selectedDate__aeMzP","nonSelectedDate":"mini-calendar_nonSelectedDate__XPqXY"};